<template>
  <div class="row">
    <div class="col-12">
      <card>
        <div class="card-body">
          <div class="row" v-if="isAdmin">
            <div class="col-12">
              <div class="float-right mb-4">
                <button class="btn btn-secondary btn-sm" @click="export2Excel">
                  <i class="fas fa-download fa-fw"></i> Download XLS
                </button>
              </div>
            </div>
          </div>
          <h2 class="mt-0 pt-0">
            <i class="fas fa-wrench text-primary"></i>{{$t('asf.title')}}
            <router-link :to="{ name: 'asfs_new' }" class="btn btn-primary float-right">{{$t('asf.button.addnew')}}</router-link>
          </h2>
          <hr>
          <div slot="raw-content" class="table-responsive">
            <paper-table
              :data="asfs"
              :columns="columns"
              :column_names="column_names"
              ref="vuetable"
              type="hover"
              edit_route="asfs_edit"
              delete_route=""
            ></paper-table>
            <!-- delete_route="asfs_delete" -->
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import PaperTable from "../../components/PaperTable";
const tableColumns = ["Id", "Name", "Vat", "Phones"];

export default {
  components: {
    PaperTable
  },
  computed: {
    ...mapState("asfs", {
      asfs: "all"
    }),
    isAdmin() {
      return this.$store.getters["auth/getIsAdmin"];
    }
  },
  data() {
    return {
      columns: [...tableColumns],
      column_names: [
        "Id",
        this.$t('asf.name'),
        this.$t('asf.cnpj'),
        this.$t('asf.phones'),
      ]
    };
  },
  mounted() {
    this.$store.dispatch("asfs/getAllAsfs");
    // console.log(this.$refs.vuetable.data);
  },
  methods: {
    getCurrentDate(){
      var myDate = new Date();
      var month = ('0' + (myDate.getMonth() + 1)).slice(-2);
      var day = ('0' + myDate.getDate()).slice(-2);
      var year = myDate.getFullYear();
      return year + '-' + month + '-' + day;
    },
    export2Excel() {
      import('@/excel/Export2Excel').then(excel => {

        const tHeader = this.columns;//['Serial number', 'Nickname?', 'Full name'];  // Set the title of the first row of Excel table
        const filterVal = ["id", "name", "vat", "phones"];//['index', 'nickName', 'name'];  // index, nickName and name are properties of objects in tableData
        const list = this.$refs.vuetable.data;  //Save tableData in data to list
        const data = this.formatJson(filterVal, list);

        excel.export_json_to_excel({
          header: tHeader, //Header Required
          data, //Specific data Required
          filename: this.$t('inventory.title') + '_' + this.getCurrentDate(), //Optional
          autoWidth: true, //Optional
          bookType: 'xlsx' //Optional
        })
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    }
  }
};
</script>
<style>
</style>
